import React from "react";
import { ESTADO } from "@/lib/constants";
import { ESTADO_ETAPA } from "@/lib/etapas";
import { cn } from "@/lib/utils";
import { t } from "@/lib/i18n";

// Fix P (2026-10-13): el recorrido son las etapas activas de la carga. Cada paso lleva su nombre y su texto (no solo el color).
const NAVY = "#223B59";

export function RutaCarga({ carga, variant = "full", className }) {
  const estado = carga?.estado;
  const color = ESTADO[estado]?.color || "#7E838C";
  const ets = (carga?.etapas || []).filter((e) => e.activa);
  const idx = ets.findIndex((e) => !e.salida_at); // -1 cuando ya terminaron todas
  if (estado === "cancelada") {
    return variant === "mini" ? (
      <div className="flex items-center gap-1" data-testid="ruta-mini">
        {[0, 1, 2, 3].map((i) => <span key={i} className="h-1 w-4 rounded-full bg-[#C9C6BF]" />)}
        <span className="text-[12px] text-ink-3 ml-1.5">{t("Cancelada")}</span>
      </div>
    ) : <p className="text-sm text-ink-3" data-testid="ruta-full">{t("Cancelada")}</p>;
  }
  if (variant === "mini") {
    const texto = ets.length === 0 ? "—" : idx === -1 ? t("Terminada") : t("{nombre} · {n} de {total}", { nombre: ets[idx].nombre, n: idx + 1, total: ets.length });
    return (
      <div data-testid="ruta-mini" title={ESTADO[estado]?.label}>
        <div className="flex items-center gap-1">
          {ets.map((e, i) => (
            <span key={e.clave} className="h-1 w-4 rounded-full" style={{ background: e.salida_at ? NAVY : i === idx ? color : "#D3CDC2" }} />
          ))}
        </div>
        <span className="mt-1 block text-[12px] text-ink-2 whitespace-nowrap" data-testid="ruta-mini-texto">{texto}</span>
      </div>
    );
  }
  return (
    <ol className={cn("flex items-start w-full overflow-x-auto", className)} data-testid="ruta-full">
      {ets.map((e, i) => {
        const done = !!e.salida_at;
        const cur = i === idx;
        const est = ESTADO_ETAPA[e.estado_etapa || (done ? "completada" : "pendiente")];
        return (
          <li key={e.clave} className="flex-1 min-w-[92px] flex flex-col items-center relative" data-testid={`ruta-paso-${e.clave}`}>
            {i > 0 && <span className="absolute top-[6px] right-1/2 w-full h-[2px]" style={{ background: i <= idx || idx === -1 ? NAVY : "#E5E1D9" }} />}
            <span
              className="relative z-10 h-[14px] w-[14px] rounded-full border-2 bg-surface"
              style={{
                borderColor: done ? NAVY : cur ? color : "#D3CDC2",
                background: done ? NAVY : cur ? color : "#fff",
                boxShadow: cur ? `0 0 0 4px ${color}33` : "none",
              }}
            />
            <span className={cn("mt-2 text-[11.5px] leading-tight text-center px-1", cur ? "font-semibold text-ink" : "text-ink-2")}>{e.nombre}</span>
            <span className="mt-0.5 text-[11px] leading-tight text-center text-ink-3">{est.label}</span>
          </li>
        );
      })}
    </ol>
  );
}
